/* istanbul ignore next */
const ACTIONS = {
    GET_MAILING_METADATA: 'GET_MAILING_METADATA',
    GET_MAILING_METADATA_SUCCESS: 'GET_MAILING_METADATA_SUCCESS',
    SET_ADDRESS_FIELD: 'SET_ADDRESS_FIELD',
    SET_FIELD_ERROR: 'SET_FIELD_ERROR',

    UPDATE_MAILING_DETAILS: 'UPDATE_MAILING_DETAILS',
    MAILING_SERVICE_ERROR: 'MAILING_SERVICE_ERROR',

    ENABLE_MAILING_PG_CONTINUE_BUTTON: 'ENABLE_MAILING_PG_CONTINUE_BUTTON',
    PRE_POPULATE_LOCAL_STATE_MAILING: 'PRE_POPULATE_LOCAL_STATE_MAILING',
    ADDRESS_CHOICE: 'ADDRESS_CHOICE'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    getMailingMetadataSuccess(mailingMetadata) {
        return {
            type: ACTIONS.GET_MAILING_METADATA_SUCCESS,
            payload: {
                mailingMetadata
            }
        };
    },

    getMailingMetadata() {
        return {
            type: ACTIONS.GET_MAILING_METADATA
        };
    },

    setAddressField(fieldName, fieldValue, addressType) {
        return {
            type: ACTIONS.SET_ADDRESS_FIELD,
            payload: {
                fieldName,
                fieldValue,
                addressType
            }
        };
    },

    updateMailingDetails(mailingDetails) {
        return {
            type: ACTIONS.UPDATE_MAILING_DETAILS,
            payload: {
                mailingDetails
            }
        };
    },

    setFieldError(fieldName, errorMsg, addressType) {
        return {
            type: ACTIONS.SET_FIELD_ERROR,
            payload: {
                fieldName,
                errorMsg,
                addressType
            }
        };
    },

    enableContinueButton() {
        return {
            type: ACTIONS.ENABLE_MAILING_PG_CONTINUE_BUTTON
        };
    },

    alertError(errorKey) {
        return {
            type: ACTIONS.MAILING_SERVICE_ERROR,
            payload: {
                errorKey
            }
        };
    },

    prePopulateLocalState(publicUuid) {
        return {
            type: ACTIONS.PRE_POPULATE_LOCAL_STATE_MAILING,
            payload: {
                publicUuid
            }
        };
    },

    setAddressChoice(fieldValue) {
        return {
            type: ACTIONS.ADDRESS_CHOICE,
            payload: {
                fieldValue
            }
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
